var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: "基础信息" } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "姓名",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "name"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入姓名" },
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.codeVisible
                        ? _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "身份证号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "code"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入身份证号",
                                      disabled: _vm.code
                                    },
                                    model: {
                                      value: _vm.model.code,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "code", $$v)
                                      },
                                      expression: "model.code"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.codeVisible
                        ? _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "身份证号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "fakeCode"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      value: "******************",
                                      placeholder: "请输入身份证号",
                                      disabled: _vm.code
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "手机",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "mobile"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入手机" },
                                model: {
                                  value: _vm.model.mobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "mobile", $$v)
                                  },
                                  expression: "model.mobile"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: "接待人信息" } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "接待人姓名",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "receptionName"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入接待人姓名" },
                                model: {
                                  value: _vm.model.receptionName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "receptionName", $$v)
                                  },
                                  expression: "model.receptionName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "接待人工号",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "receptionCode"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入接待人工号" },
                                model: {
                                  value: _vm.model.receptionCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "receptionCode", $$v)
                                  },
                                  expression: "model.receptionCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "接待人手机",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "receptionMobile"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入接待人手机" },
                                model: {
                                  value: _vm.model.receptionMobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "receptionMobile", $$v)
                                  },
                                  expression: "model.receptionMobile"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: "拜访信息" } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "拜访法人",
                                labelCol: _vm.labelCol2,
                                wrapperCol: _vm.wrapperCol2,
                                prop: "corporation"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { placeholder: "请输入拜访法人" },
                                model: {
                                  value: _vm.model.corporation,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "corporation", $$v)
                                  },
                                  expression: "model.corporation"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "拜访事业群",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "businessGroupVal"
                              }
                            },
                            [
                              _c("a-select", {
                                attrs: {
                                  labelInValue: "",
                                  allowClear: "",
                                  placeholder: "请选择拜访事业群",
                                  options: _vm.businessGroupOptions
                                },
                                on: { change: _vm.handleGroupVal },
                                model: {
                                  value: _vm.model.businessGroupVal,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "businessGroupVal", $$v)
                                  },
                                  expression: "model.businessGroupVal"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "拜访事业处",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "businessUnitVal"
                              }
                            },
                            [
                              _c("a-select", {
                                attrs: {
                                  labelInValue: "",
                                  allowClear: "",
                                  placeholder: "请选择拜访事业处",
                                  options: _vm.businessUnitOptions
                                },
                                on: { change: _vm.handleUnitVal },
                                model: {
                                  value: _vm.model.businessUnitVal,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "businessUnitVal", $$v)
                                  },
                                  expression: "model.businessUnitVal"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "访问厂区",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "factoryId"
                              }
                            },
                            [
                              _c("a-select", {
                                attrs: {
                                  allowClear: "",
                                  placeholder: "请选择访问厂区",
                                  options: _vm.factoryOptions
                                },
                                on: { change: _vm.factoryChange },
                                model: {
                                  value: _vm.model.factoryId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "factoryId", $$v)
                                  },
                                  expression: "model.factoryId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "访问区域",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "areaId"
                              }
                            },
                            [
                              _c("a-select", {
                                attrs: {
                                  allowClear: "",
                                  placeholder: "请选择访问区域",
                                  options: _vm.areaOptions
                                },
                                on: { change: _vm.areaChange },
                                model: {
                                  value: _vm.model.areaId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "areaId", $$v)
                                  },
                                  expression: "model.areaId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "停留楼栋",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "buildingId"
                              }
                            },
                            [
                              _c("a-select", {
                                attrs: {
                                  allowClear: "",
                                  placeholder: "请选择停留楼栋",
                                  options: _vm.buildingOptions
                                },
                                on: { change: _vm.buildingChange },
                                model: {
                                  value: _vm.model.buildingId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "buildingId", $$v)
                                  },
                                  expression: "model.buildingId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "拜访时间",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "visitTime"
                              }
                            },
                            [
                              _c("j-date", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择拜访时间",
                                  "show-time": true,
                                  "date-format": "YYYY-MM-DD HH:mm:ss"
                                },
                                model: {
                                  value: _vm.model.visitTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "visitTime", $$v)
                                  },
                                  expression: "model.visitTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "离去时间",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "leaveTime"
                              }
                            },
                            [
                              _c("j-date", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择离去时间",
                                  "show-time": true,
                                  "date-format": "YYYY-MM-DD HH:mm:ss"
                                },
                                model: {
                                  value: _vm.model.leaveTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "leaveTime", $$v)
                                  },
                                  expression: "model.leaveTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: "拜访人核酸信息" } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "核酸检测时间",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "detectionTime"
                              }
                            },
                            [
                              _c("j-date", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择核酸检测时间",
                                  "show-time": true,
                                  "date-format": "YYYY-MM-DD HH:mm:ss"
                                },
                                model: {
                                  value: _vm.model.detectionTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "detectionTime", $$v)
                                  },
                                  expression: "model.detectionTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "健康码状态",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "healthCode"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "list",
                                  dictCode: "pre_health_status",
                                  placeholder: "请选择健康码状态"
                                },
                                model: {
                                  value: _vm.model.healthCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "healthCode", $$v)
                                  },
                                  expression: "model.healthCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "上传健康码截图",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "healthImage"
                              }
                            },
                            [
                              _c("j-image-upload", {
                                attrs: {
                                  bizPath: "health",
                                  uploadSource: "prevent"
                                },
                                model: {
                                  value: _vm.model.healthImage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "healthImage", $$v)
                                  },
                                  expression: "model.healthImage"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }